<template>
  <div class="objects-search_osh" :class="{ [curTheme]: true }">
    <div class="page-container_pcr">

      <template  v-if="$route.path === '/objects/search'">
        <button-back class="osh_button-back" v-if="$route.path === '/objects/search'"/>
        <app-subscribe class="osh_app-subscribe" :key="`app-subscribe-${subscribeBtnKeyId}`"/>
        <div
          v-if="found && orders && order !== ''"
          class="search-order_sor">
          <i class="sor_icon el-icon-menu"/>
          <el-select
            class="sor_input"
            placeholder="Сортировка..."
            @change="onOrderChanged"
            v-model="order">
            <el-option
              v-for="(val, key, i) in orders"
              :key="`order-option-${i}`"
              :label="val"
              :value="key">
            </el-option>
          </el-select>
        </div>
      </template>

      <div class="no-results" v-if="!loading && !found">
        {{ nothingFoundText }}
        <div
          v-if="$route.path === '/user/objects'"
          class="depo-msg_dmg dmg_btn dmg_themable"
          @click="$router.push({ path: '/objects/add' })">
          <div class="dmg_plus"></div>
          <div class="dmg_icon"></div>
          <div class="dmg_text">Можете приступить к депонированию Вашего
            первого объекта.</div>
        </div>
        <div
          v-else-if="$route.path === '/objects/search'"
          class="depo-msg_dmg dmg_btn dmg_themable"
          @click="$router.push({ path: '/user/register' })">
          <div class="dmg_plus"></div>
          <div class="dmg_icon"></div>
          <div class="dmg_text">
            Также Вы можете задепонировать свои объекты интеллектуальной
            собственности. Для этого Вам достаточно зарегистрироваться.</div>
        </div>
        <div
          v-else-if="$route.path === '/user/recommendations'"
          class="depo-msg_dmg dmg_themable">
          <div class="dmg_icon"></div>
          <div class="dmg_text">
            В процессе работы с системой о вашей активности будет накапливаться
            информация, и мы сможем порекомендовать вам объекты согласно вашим интересам.</div>
        </div>
      </div>

      <object-teaser
        v-for="(el, i) in objects"
        :key="`object-teaser-${i}`"
        dataType="object"
        :dataSource="el"/>

      <div
        v-if="loading"
        class="osh_loading">
        <i class="el-icon-loading"></i> Загрузка...
      </div>

      <el-pagination
        v-show="paginationVisible"
        :page-size="limit"
        :total="found"
        :current-page="currentPage"
        @current-change="currentChange"
        layout="prev, pager, next, jumper"/>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AppSubscribe from '@/components/AppSubscribe';
import Misc from '../../mixins/Misc';
import ObjectTeaser from '../ObjectTeaser';
import ButtonBack from '../ButtonBack';

export default {

  mixins: [Misc],

  components: { ObjectTeaser, ButtonBack, AppSubscribe },

  props: {
    nothingFoundText: {
      default: 'Не найдено ни одного объекта. Попробуйте изменить параметры поиска.',
    },
  },

  data() {
    return {
      orders: null,
      order: '',
      objects: [],
      found: 1,
      limit: 0,
      offset: 0,
      currentPage: 1,
      paginationVisible: false,
      refreshInterval: null,
      refreshTime: 10000,
      loading: false,
      subscribeBtnKeyId: 0,
    };
  },

  created() {
    this.fetchData();
    if (this.$route.path === '/user/objects') {
      this.refreshInterval = setInterval(this.fetchData, this.refreshTime);
    }
  },

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },

  watch: {
    $route() {
      this.fetchData();
    },
  },

  methods: {

    onOrderChanged(order) {
      const query = Object.assign({}, this.$route.query);
      query.order = order;
      this.$router.push({ path: this.$route.path, query });
      this.scrollTop();
    },

    fetchData() {
      this.subscribeBtnKeyId = Math.random();
      const userId = this.$store.getters['user/getUserId'];
      const router = this.$route;
      const isAuthorPage = (
        router.matched && router.matched.length > 0
          && router.matched[0].path === '/user/:userId/profile/view');
      if (this.$route.path === '/user/recommendations' && userId) {
        axios.get(`recommendations/users/${userId}`).then((r) => {
          const rLoc = {
            data: {
              Found: 1,
              Objects: r.data,
            },
          };
          this.processResponse(rLoc);
        });
      } else if (this.$route.path === '/user/objects' && userId) {
        // Search user objects
        const query = {};
        if (this.$route.query.limit) query.offset = this.$route.query.limit;
        if (this.$route.query.offset) query.offset = this.$route.query.offset;
        axios.get(`objects/my/${userId}`, { params: query }).then(this.processResponse);
      } else if (isAuthorPage) {
        // Search user objects
        this.objects = [];
        this.paginationVisible = false;
        this.loading = true;
        // Search objects
        if (typeof this.$route.params.userId !== 'undefined') {
          this.$route.query.authorId = this.$route.params.userId;
        }
        axios.get('objects/search', { params: this.$route.query }).then(this.processResponse);
      } else {
        this.objects = [];
        this.paginationVisible = false;
        this.loading = true;
        // Search objects
        if (userId) {
          this.$route.query.userId = userId;
        }
        axios.get('objects/search', { params: this.$route.query }).then(this.processResponse);
      }
    },

    processResponse(response) {
      this.loading = false;
      this.limit = typeof this.$route.query.limit !== 'undefined' ? this.$route.query.limit : 20;
      this.offset = typeof this.$route.query.offset !== 'undefined' ? this.$route.query.offset : 0;
      this.order = response.data.Order;
      this.orders = response.data.Orders;
      this.found = response.data.Found;
      this.paginationVisible = Math.floor((this.found - 1) / this.limit) > 0;
      this.currentPage = Math.floor(this.offset / this.limit) + 1;
      // Check if update is needed and perform this update
      const newObjects = response.data.Objects;
      let needUpdate = (newObjects && newObjects.length !== this.objects.length);
      if (!needUpdate && newObjects) {
        for (let i = 0; i < newObjects.length; i += 1) {
          if (needUpdate) break;
          needUpdate = (this.objects.findIndex(oldObject =>
            oldObject.ObjectId === newObjects[i].ObjectId) === -1);
        }
        for (let i = 0; i < this.objects.length; i += 1) {
          if (needUpdate) break;
          needUpdate = (newObjects.findIndex(newObject =>
            newObject.ObjectId === this.objects[i].ObjectId) === -1);
        }
      }
      if (needUpdate) {
        this.objects = [];
        this.$nextTick(() => {
          this.objects = newObjects;
        });
      }
    },

    currentChange(curPage) {
      const query = Object.assign({}, this.$route.query);
      query.offset = this.limit * (curPage - 1);
      this.$router.push({ path: this.$route.path, query });
      this.scrollTop();
    },

  },
};
</script>

<style lang="scss">
@import "../../styles/common/main";

.objects-search_osh {
  margin: 20px 0;
  @include clearfix;
  .page-container_pcr {
    position: relative;
  }
  .osh_button-back {
    position: absolute;
    left: 25px;
    top: 0;
    @media (max-width: 767px) {
      left: 15px;
    }
  }
  .osh_app-subscribe {
    display: block;
    margin: 0 auto;
    @media (max-width: 990px) {
      margin-left: 70px;
    }
    @media (max-width: 500px) {
      float: right;
    }
  }
}

.osh_loading {
  text-align: center;
  font-size: 15px;
  padding: 100px 30px;
  border: 1px dashed #fff;
  margin: 100px 0;
  border-radius: 25px;
  opacity: .6;
  i {
    color: #ccc;
    display: inline-block;
    font-size: 22px;
    vertical-align: baseline;
    margin-right: 8px;
  }
}

.search-order_sor {
  position: absolute;
  right: 20px;
  top: 7px;
  white-space: nowrap;
  .sor_icon {
    display: inline-block;
    vertical-align: middle;
    margin: -4px -9px 0 0;
  }
  .sor_input {
    width: 260px;
    .el-input__inner {
      background: transparent;
      @include box-shadow(none);
      @include transition;
      &:hover {
        color: #888;
      }
    }
  }
  @media (max-width: 767px) {
    right: 10px;
  }
  @media (max-width: 500px) {
    position: static;
    padding-top: 70px;
    text-align: center;
    padding-left: 15px;
    .sor_input {
      width: 260px;
    }
  }
}

.theme-b {
  .sor_icon {
    color: #999;
  }
  .sor_input {
    .el-input__inner {
      color: #bbb;
    }
  }
}

.theme-w {
  .sor_icon {
    color: #999;
  }
  .sor_input {
    .el-input__inner {
      color: #bbb;
    }
  }
  .osh_loading {
    border: 1px dashed #333;
    i {
      color: #666;
    }
  }
}

.no-results {
  text-align: center;
  font-size: 16px;
  margin-top: 90px;
  @media (max-width: 1000px) {
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/ObjectsSearch.vue